import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../store/AuthContext";
import {
  verifyTwoFactorCodeWithoutSecret,
  verifyTwoFactorCodeWithSecret,
} from "../../services/authService";
import { toast, ToastContainer } from "react-toastify";

function TwoFactorAuth() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    if (authCtx?.isLoggedIn) navigate("/");
    // eslint-disable-next-line
  }, [authCtx]);

  useEffect(() => {
    if (!location.state) {
      toast("Invalid access to 2FA page.");
      navigate("/login"); // or wherever is appropriate
    }
  }, [location.state, navigate]);

  const { enabled, email, secret, qrCode } = location.state || {};

  const [token, setToken] = useState("");
  const [verified, setVerified] = useState(enabled);

  const verifyTokenFirstTime = async () => {
    try {
      const res = await verifyTwoFactorCodeWithSecret({
        secret,
        token,
        email,
      });

      authCtx.login(
        res.data.token,
        res.data.role === "Admin",
        res.data.role === "SuperAdmin",
        {
          name: res.data.name,
          email: res.data.email,
          organization: res.data.organization,
        }
      );

      if (res.data.hasResetPassword === false) {
        // setLoading(false);
        navigate("/reset-password");
      } else {
        // setLoading(false);
        navigate("/");
      }

      console.log(res);
    } catch (e) {
      toast(
        e?.response?.data?.message
          ? e?.response?.data?.message
          : "An error occured. Please try again"
      );
    }
  };

  const checkToken = async () => {
    try {
      const res = await verifyTwoFactorCodeWithoutSecret({
        token,
        email,
      });

      authCtx.login(
        res.data.token,
        res.data.role === "Admin",
        res.data.role === "SuperAdmin",
        {
          name: res.data.name,
          email: res.data.email,
          organization: res.data.organization,
          AI: res.data.AI,
        }
      );

      if (res?.data?.hasResetPassword === false) {
        // setLoading(false);
        navigate("/reset-password");
      } else {
        // setLoading(false);
        navigate("/");
      }

      console.log(res);
    } catch (e) {
      toast(
        e?.response?.data?.message
          ? e?.response?.data?.message
          : "An error occured. Please try again"
      );
    }
  };

  return (
    <div className="authWrapper">
      <ToastContainer />
      <div
        className="centerDiv"
        style={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          maxWidth: "300px",
        }}
      >
        <h1
          style={{
            margin: 0,
            color: "white",
            fontSize: "20px",
          }}
          className="loginCardTitle"
        >
          Two-Factor Authentication
        </h1>
        {qrCode ? (
          <h1
            style={{
              margin: 0,
              textAlign: "center",
              color: "white",
              fontSize: "12px",
            }}
            className="loginCardTitle"
          >
            Scan this QR code using your Google Authenticator or Microsoft
            Authenticator app to set up two-factor authentication.
          </h1>
        ) : (
          <h1
            style={{
              margin: 0,
              textAlign: "center",
              color: "white",
              fontSize: "12px",
            }}
            className="loginCardTitle"
          >
            Enter the token provided by your authentication app.
          </h1>
        )}

        {qrCode && (
          <img
            style={{
              width: "150px",
              borderRadius: "10px",
            }}
            src={qrCode}
            alt="QR Code"
          />
        )}
        <input
          autoFocus
          type="text"
          style={{ width: "100%" }}
          value={token}
          onKeyDown={(i) => {
            if (i.key === "Enter") {
              if (enabled) {
                checkToken();
              } else {
                verifyTokenFirstTime();
              }
            }
          }}
          onChange={(e) => setToken(e.target.value)}
          placeholder="Enter the token"
        />
        <button
          style={{
            display: "flex",
            width: "100%",
            height: "40px",
            background: "rgb(110, 117, 255)",
            borderRadius: "5px",
            border: "1px solid rgb(110, 117, 255)",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            cursor: "pointer",
            padding: "0px 5px",
            gap: "5px",
            fontSize: "15px",
          }}
          onClick={() => {
            if (enabled) {
              checkToken();
            } else {
              verifyTokenFirstTime();
            }
          }}
        >
          Verify Token
        </button>
      </div>
    </div>
  );
}

export default TwoFactorAuth;
